import {
  FETCH_USER_DATA_REQUEST,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_FAILURE,
  CHANGE_USER_STATUS_REQUEST,
  CHANGE_USER_STATUS_SUCCESS,
  CHANGE_USER_STATUS_FAILURE,
  FETCH_TEAMS_REQUEST,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_FAILURE,
  UPDATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
} from "../actions/userActions";

const userInitialState = {
  data: [],
  loading: false,
  error: null,
};

const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case FETCH_USER_DATA_REQUEST:
    case CREATE_USER_REQUEST:
    case CHANGE_USER_PASSWORD_REQUEST:
    case UPDATE_USER_REQUEST:
      return { ...state, loading: true };
    case FETCH_USER_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case CREATE_USER_SUCCESS:
    case CHANGE_USER_PASSWORD_SUCCESS:
    case CHANGE_USER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload],
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((user) =>
          user.id === action.payload.id ? { ...user, ...action.payload } : user
        ),
      };
    case FETCH_USER_DATA_FAILURE:
    case CREATE_USER_FAILURE:
    case CHANGE_USER_PASSWORD_FAILURE:
    case CHANGE_USER_STATUS_FAILURE:
    case UPDATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_TEAMS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TEAMS_SUCCESS:
      return {
            ...state,
            loading: false,
            projects: action.payload, // Payload now contains `data` and `meta`
      };

    case FETCH_TEAMS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CHANGE_USER_STATUS_REQUEST:
      return {
        ...state,
        loading: false,
        data: state.data.map((user) =>
          user.email === action.payload
            ? {
                ...user,
                status: user.status == "ACTIVE" ? "INACTIVE" : "ACTIVE",
              }
            : user
        ),
      };
    default:
      return state;
  }
};

export default userReducer;
